import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/user-42.jpg'


const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-0" }
const _hoisted_3 = { class: "default-table-area style-two all-projects pb-4" }
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = { class: "table align-middle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "p-4" }, [
        _createElementVNode("h3", { class: "mb-0" }, "Courses")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _cache[9] || (_cache[9] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", { scope: "col" }, "ID"),
                _createElementVNode("th", { scope: "col" }, "Course Name"),
                _createElementVNode("th", { scope: "col" }, "Category"),
                _createElementVNode("th", { scope: "col" }, "Instructor"),
                _createElementVNode("th", { scope: "col" }, "Enrolled"),
                _createElementVNode("th", { scope: "col" }, "Start Date"),
                _createElementVNode("th", { scope: "col" }, "End Date"),
                _createElementVNode("th", { scope: "col" }, "Price"),
                _createElementVNode("th", { scope: "col" }, "Action")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _cache[2] || (_cache[2] = _createElementVNode("td", { class: "text-body" }, "#854", -1)),
                _createElementVNode("td", null, [
                  _createVNode(_component_RouterLink, { to: "/lms/course-details" }, {
                    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                      _createTextVNode("Cybersecurity Awareness", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _cache[3] || (_cache[3] = _createElementVNode("td", null, "Technology", -1)),
                _createElementVNode("td", null, [
                  _createVNode(_component_RouterLink, {
                    to: "/lms/instructors",
                    class: "d-flex align-items-center"
                  }, {
                    default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                      _createElementVNode("div", { class: "flex-shrink-0" }, [
                        _createElementVNode("img", {
                          src: _imports_0,
                          class: "wh-34 rounded-circle",
                          alt: "user"
                        })
                      ], -1),
                      _createElementVNode("div", { class: "flex-grow-1 ms-2 position-relative top-1" }, [
                        _createElementVNode("h6", { class: "mb-0 fs-14 fw-medium" }, "Oliver Khan")
                      ], -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _cache[4] || (_cache[4] = _createElementVNode("td", { class: "text-body" }, "180", -1)),
                _cache[5] || (_cache[5] = _createElementVNode("td", { class: "text-body" }, "25 Mar 2024", -1)),
                _cache[6] || (_cache[6] = _createElementVNode("td", { class: "text-body" }, "25 Apr 2024", -1)),
                _cache[7] || (_cache[7] = _createElementVNode("td", null, "$49.99", -1)),
                _cache[8] || (_cache[8] = _createElementVNode("td", null, [
                  _createElementVNode("div", { class: "d-flex align-items-center gap-2" }, [
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary" }, " visibility ")
                    ]),
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-body" }, " edit ")
                    ]),
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-danger" }, " delete ")
                    ])
                  ])
                ], -1))
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}